export default {"src":"/_next/static/media/error_image.dc084521.svg","height":500,"width":600,"blurWidth":0,"blurHeight":0};